import Axios from 'axios';
import {AxiosProcessor} from "@/shared/axios/AxiosProcessor";
import {USER_TYPE} from "@/shared/enums/UserType";

const urlClientType = '/groupType';

const state = {
    clientType: {},
    clientTypes:[],
    clientTypesKey:{}
};

const getters = {
    getClientType: state => {
        return state.clientType;
    },
    getClientTypes: state => {
        return state.clientTypes;
    },
    getClientTypesKey: state => {
        return state.clientTypesKey;
    }
};

const mutations = {
    setClientType: (state, data) => {
        state.clientType = data;
    },
    setClientTypes: (state, data) => {
        state.clientTypes = data;
    },
    setClientTypesKey: (state, data) => {
        state.clientTypesKey = data;
    }
};

const actions = {
    async setClientType ({commit}, data) {
        //going backend
        let value = {};

        try{
            let response = {};
            if(!!!data.id) {
                response  = await Axios.post(urlClientType, data);
            }
            else {
                response = await Axios.put(urlClientType+'/'+ data.id, data);
            }
            value = response.data.body;
        }
        catch (e) {
            console.log('Error: ', e);
            throw e;
        }
        commit('setClientType', value);
    },
    async getClientType ({commit}, data) {

        let id = data.id;

        if (!id)
            throw {message: 'empty id. Please provide a valid id value'};

        /**
         * First we check the state
         * then we check the list
         * then we go to backend
         */
        if(state.clientType.id && state.clientType.id === id)
            return;

        let clientType;
        let value = {};

        if (state.clientTypes.length > 0) {
            clientType  = state.clientTypes.find(pat => pat.id === id);
        }

        if(clientType)
        {
            value = clientType;
        }
        else
        {
            let response = await AxiosProcessor.get(urlClientType+'/'+data.id);

            if(response.Item)
                value = response.Item;
        }

        commit('setClientType', value);
    },
    async getClientTypes ({commit}, data){
        let value = [];
        let response = await AxiosProcessor.list(urlClientType+'/types/'+USER_TYPE.CLIENT, data);

        if(response.Items)
            value = response.Items;

        commit('setClientTypes', value);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}